
import { useState } from 'react';

interface PricingHeroProps {
  billingPeriod: 'monthly' | 'annual';
  onBillingChange: (period: 'monthly' | 'annual') => void;
}

export default function PricingHero({ billingPeriod, onBillingChange }: PricingHeroProps) {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-[#e4f4ff]/20 via-white to-[#b3d9ff]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center px-4 py-2 bg-[#e4f4ff]/30 rounded-full text-[#22577A] font-medium mb-6">
          <i className="ri-price-tag-3-line mr-2"></i>
          Simple, Transparent Pricing
        </div>

        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#22577A] mb-6">
          Choose Your Perfect
          <span className="block text-[#38a3a5]">Marketing Plan</span>
        </h1>

        <p className="text-xl text-gray-700 mb-12 max-w-3xl mx-auto">
          Start with a 14-day free trial. No credit card required. Upgrade, downgrade, or cancel anytime.
        </p>

        {/* Billing Toggle */}
        <div className="flex items-center justify-center gap-4 mb-4">
          <span
            className={`font-medium ${
              billingPeriod === 'monthly' ? 'text-[#22577A]' : 'text-gray-500'
            }`}
          >
            Monthly
          </span>
          <button
            onClick={() =>
              onBillingChange(billingPeriod === 'monthly' ? 'annual' : 'monthly')
            }
            className="relative w-16 h-8 bg-gradient-to-r from-[#38a3a5] to-[#66b3ff] rounded-full transition-all cursor-pointer"
          >
            <div
              className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform ${
                billingPeriod === 'annual' ? 'translate-x-9' : 'translate-x-1'
              }`}
            ></div>
          </button>
          <span
            className={`font-medium ${
              billingPeriod === 'annual' ? 'text-[#22577A]' : 'text-gray-500'
            }`}
          >
            Annual
          </span>
          <div className="bg-[#b3d9ff]/30 text-[#22577A] px-3 py-1 rounded-full text-sm font-semibold">
            Save 20%
          </div>
        </div>
      </div>
    </section>
  );
}
